import { render, staticRenderFns } from "./InBody.vue?vue&type=template&id=0f6a0a64&scoped=true&"
import script from "./InBody.vue?vue&type=script&lang=js&"
export * from "./InBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6a0a64",
  null
  
)

export default component.exports